// opervex-frontend/src/pages/System/Setting.js
import { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Form, Image, Card, Button, InputGroup } from "react-bootstrap";
import { FaPlus, FaSave, FaPencilAlt, FaSearch } from "react-icons/fa";
import { MdOutlineCancel } from "react-icons/md";

import { useAuth } from "../../contexts/AuthContext";
import useOpervex from "../../hooks/useOpervex";
import ConfirmService from "../../components/ConfirmationModal/ConfirmService";
import { SearchHelpModal } from "../../utils/SearchHelp";

const dataDefault = {
  id: "",
  description: "",

  mailProtocol: null,
  mailServer: "",
  mailPort: "",
  mailUsername: "",
  mailPassword: "",

  pointVendor: "",
  pointApikey: "",
  pointEndpoint: "",
  pointUsername: "",
  pointPassword: "",

  image: { type: "", name: "", length: 0, base64: "" },
};

const actionsDefault = {
  create: true,
  change: true,
  delete: true,
  save: true,
};

const Setting = () => {
  const { loadingGlobal } = useAuth();
  const [disabledField, setDisabledField] = useState(true);
  const [actions, setActions] = useState(actionsDefault);
  const [data, setData] = useState(dataDefault);
  const [operation, setOperation] = useState({});
  const id = "DEFAULT";
  const OpervexAPI = useOpervex();
  const originalValues = useRef({});

  useEffect(() => {
    const fetchData = async () => {
      await searchAPI(id);
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loadingGlobal) return <div>Carregando...</div>;

  const commandAction = (actions, idCurrent) => {
    if (!actions.create || !actions.change) {
      actions.create = !(idCurrent === "");
      actions.change = !(idCurrent !== "");
    }

    setActions({ ...actions });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newData = { ...data, [name]: type === "checkbox" ? checked : value };
    setData(newData);
  };

  const handleOsOperation = async (onClick, value) => {
    let id = null;

    if (onClick) {
      const item = await SearchHelpModal({
        urlData: "/System/OperationGoodsMovement/SearchHelp",
        schema: await OpervexAPI.System.OperationGoodsMovement.schema(),
      });

      if (!item) return;

      id = item.id;
    } else {
      if (!value) return;

      id = value;
    }

    if (!id) return;

    let operation = await OpervexAPI.System.OperationGoodsMovement.findId(id);

    if (!operation) operation = { id: "" };

    if (operation) setOperation(operation);
    else setOperation({});

    setData((prev) => ({
      ...prev,
      osOperation: operation.id,
    }));
  };

  const handleFocus = (event, index, name, row) => {
    originalValues.current[`${index}_${name}`] = event.target.value;
  };

  const handleBlur = (event, index, name, row) => {
    const originalValue = originalValues.current[`${index}_${name}`];
    const currentValue = event.target.value;

    if (originalValue === currentValue) return;

    switch (name) {
      case "osOperation":
        handleOsOperation(false, currentValue);
        break;
      default:
        break;
    }
  };

  const handleButtonCreate = () => {
    setData(dataDefault);
    commandAction({ ...actionsDefault, save: false }, dataDefault.id);
    setDisabledField(false);
  };

  const handleButtonCancel = () => {
    if (data.id === "") {
      setData(dataDefault);
      setDisabledField(true);
      commandAction({ ...actionsDefault, create: false }, dataDefault.id);
    } else {
      searchAPI(data.id);
    }
  };

  const handleButtonSave = async () => {
    const body = { ...data };

    if (!body.mailProtocol) {
      body.mailServer = null;
      body.mailPort = null;
      body.mailUsername = null;
      body.mailPassword = null;
    }

    if (!body.pointVendor) {
      body.pointApikey = null;
      body.pointEndpoint = null;
      body.pointUsername = null;
      body.pointPassword = null;
    }

    if (body.id === "") {
      const result = await OpervexAPI.System.Setting.create(body);

      if (result.errors) {
        await ConfirmService.show("Aviso", result.errors, true);
        return;
      }

      await searchAPI(body.id);
      alert("Registro criado com sucesso!");
    } else {
      const result = await OpervexAPI.System.Setting.update(body.id, body);

      if (result.errors) {
        await ConfirmService.show("Aviso", result.errors, true);
        return;
      }
      await searchAPI(body.id);
      alert("Registro atualizado com sucesso!");
    }
  };

  const handleButtonChange = async () => {
    setDisabledField(false);
    commandAction({ ...actionsDefault, save: false }, data.id);
  };

  const searchAPI = async (id) => {
    setDisabledField(true);
    if (!id) return;

    const result = await OpervexAPI.System.Setting.findId(id);

    if (result && !result.error) {
      setData(result);

      if (result.osOperation) {
        const operation = await OpervexAPI.System.OperationGoodsMovement.findId(result.osOperation);

        if (operation) setOperation(operation);
        else setOperation({});
      }
      commandAction({ ...actionsDefault, create: false, change: false }, result.id);
    } else {
      setData(dataDefault);
      commandAction({ ...actionsDefault, create: false }, dataDefault.id);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const reader = new FileReader();

    reader.onload = () => {
      const base64 = reader.result.split(",")[1];

      setData((prev) => ({
        ...prev,
        image: {
          name: file.name,
          type: file.type,
          size: file.size,
          base64,
        },
      }));
    };

    reader.readAsDataURL(file);
  };

  const removeImage = () => {
    setData((prev) => ({
      ...prev,
      image: { type: "", name: "", length: 0, base64: "" },
    }));
  };

  return (
    <Container className="mt-2">
      <Form>
        {/* ----- Header -----*/}
        <Card className="mb-2">
          <Card.Header>
            <Row className="d-flex justify-content-between">
              <Col md={8}>
                <h5>Cabeçalho</h5>
              </Col>
              <Col md={4} className="text-end">
                <Button variant="success" size="sm" className="me-2" onClick={handleButtonCreate} hidden={actions.create}>
                  <FaPlus /> Novo
                </Button>
                <Button variant="primary" size="sm" className="me-2" onClick={handleButtonChange} hidden={actions.change}>
                  <FaPencilAlt /> Alterar
                </Button>
                <Button variant="danger" size="sm" className="me-2" onClick={handleButtonCancel} hidden={actions.save}>
                  <MdOutlineCancel /> Cancelar
                </Button>
                <Button variant="primary" size="sm" className="me-2" onClick={handleButtonSave} hidden={actions.save}>
                  <FaSave /> Salvar
                </Button>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <Row className="mb-2">
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Código</Form.Label>
                  <Form.Control type="text" size="sm" value={data.id ?? ""} name="id" disabled />
                </Form.Group>
              </Col>
              <Col md={9}>
                <Form.Group>
                  <Form.Label>Descrição</Form.Label>
                  <Form.Control
                    type="text"
                    size="sm"
                    name="description"
                    value={data.description ?? ""}
                    onChange={handleChange}
                    disabled={disabledField}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* ----- Configuração de E-mail -----*/}
        <Card className="mb-2">
          <Card.Header>
            <h5>Configuração de e-mail</h5>
          </Card.Header>
          <Card.Body>
            <Row className="mb-2">
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Protocolo</Form.Label>
                  <Form.Select
                    size="sm"
                    value={data.mailProtocol ?? 0}
                    onChange={handleChange}
                    name="mailProtocol"
                    disabled={disabledField}
                  >
                    <option value={0}>Selecione...</option>
                    <option value={1}>SMTP</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Servidor</Form.Label>
                  <Form.Control
                    type="text"
                    size="sm"
                    name="mailServer"
                    value={data.mailServer ?? ""}
                    onChange={handleChange}
                    disabled={disabledField}
                  />
                </Form.Group>
              </Col>
              <Col md={1}>
                <Form.Group>
                  <Form.Label>Porta</Form.Label>
                  <Form.Control
                    type="text"
                    size="sm"
                    name="mailPort"
                    value={data.mailPort ?? ""}
                    onChange={handleChange}
                    disabled={disabledField}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Usuário</Form.Label>
                  <Form.Control
                    type="text"
                    size="sm"
                    name="mailUsername"
                    value={data.mailUsername ?? ""}
                    onChange={handleChange}
                    disabled={disabledField}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Senha</Form.Label>
                  <Form.Control
                    type="password"
                    size="sm"
                    name="mailPassword"
                    value={data.mailPassword ?? ""}
                    onChange={handleChange}
                    disabled={disabledField}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* ----- API Ponto -----*/}
        <Card className="mb-2">
          <Card.Header>
            <h5>API Ponto</h5>
          </Card.Header>
          <Card.Body>
            <Row className="mb-2">
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Fornecedor</Form.Label>
                  <Form.Select
                    size="sm"
                    value={data.pointVendor ?? ""}
                    onChange={handleChange}
                    name="pointVendor"
                    disabled={disabledField}
                  >
                    <option value="">Selecione...</option>
                    <option value={1}>Ícarus</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Apikey</Form.Label>
                  <Form.Control
                    type="text"
                    size="sm"
                    name="pointApikey"
                    value={data.pointApikey ?? ""}
                    onChange={handleChange}
                    disabled={disabledField}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Endpoint</Form.Label>
                  <Form.Control
                    type="text"
                    size="sm"
                    name="pointEndpoint"
                    value={data.pointEndpoint ?? ""}
                    onChange={handleChange}
                    disabled={disabledField}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col md={2}></Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Usuário</Form.Label>
                  <Form.Control
                    type="text"
                    size="sm"
                    name="pointUsername"
                    value={data.pointUsername ?? ""}
                    onChange={handleChange}
                    disabled={disabledField}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Senha</Form.Label>
                  <Form.Control
                    type="password"
                    size="sm"
                    name="pointPassword"
                    value={data.pointPassword ?? ""}
                    onChange={handleChange}
                    disabled={disabledField}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* ----- Additional Data -----*/}
        <Card className="mb-2">
          <Card.Header>
            <h5>Configurações Adicionais</h5>
          </Card.Header>
          <Card.Body>
            <Row className="mb-2">
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Operação - OS</Form.Label>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      size="sm"
                      value={data.osOperation ? data.osOperation : ""}
                      name="osOperation"
                      onChange={handleChange}
                      disabled={disabledField}
                      onFocus={(event) => handleFocus(event, null, "osOperation", null)}
                      onBlur={(event) => handleBlur(event, null, "osOperation", null)}
                    />

                    <InputGroup.Text size="sm" type="button" onClick={(e) => handleOsOperation(true)}>
                      <FaSearch />
                    </InputGroup.Text>
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Descrição</Form.Label>
                  <InputGroup>
                    <Form.Control type="text" size="sm" value={operation?.text ?? ""} disabled={true} />
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* ----- Imagens -----*/}
        <Card className="mb-2">
          <Card.Header>
            <h5>Imagens</h5>
          </Card.Header>

          <Card.Body>
            <Row>
              <Col md={4}>
                <Form.Group className="d-flex flex-column align-items-center">
                  <span className="border rounded p-2 mb-3">
                    <Image
                      width={200}
                      height={200}
                      style={{
                        objectFit: "contain",
                      }}
                      src={data?.image?.base64 ? `data:${data.image.type};base64,${data.image.base64}` : "/imagens/not-found.png"}
                      alt="Preview"
                      rounded
                    />
                  </span>

                  <Form.Control id="image-upload" type="file" accept="image/*" onChange={handleImageChange} hidden />

                  <Button as="label" htmlFor="image-upload" variant="primary" hidden={disabledField}>
                    Selecionar imagem
                  </Button>

                  {data?.image?.base64 && (
                    <Button variant="outline-danger" className="mt-2" onClick={removeImage} hidden={disabledField}>
                      Remover imagem
                    </Button>
                  )}
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Form>
    </Container>
  );
};

export default Setting;
